import React, { Fragment, useState } from "react";
import { withParams } from "../../utils/SharedUtils";
const JobItem = (props) => {
    const [job, setJob] = useState(props.job ? props.job : null);
    return (
        <Fragment>
            {
                job ?
                    (
                        <li className="experience__section-container__experience-list" style={{color:'var(--primary-color)'}}>
                            <div className="experience__section-container__experience-list__internal-row">
                                <p>
                                    <b>Cargo: </b>
                                </p>
                                <span>
                                    {job.title}
                                </span>
                            </div>
                            <div className="experience__section-container__experience-list__internal-row">
                                <p>
                                    <b>Empresa: </b>
                                </p>
                                <span className="badge rounded-pill bg-secondary badge-company">
                                    <a target="_blank" href={job.company_url}>
                                        {job.company_name}
                                    </a>
                                </span>
                            </div>
                            <div className="experience__section-container__experience-list__internal-row">
                                <p>
                                    <b>Fecha: </b>
                                </p>
                                <span className="badge rounded-pill bg-secondary badge-date">
                                    del {job.start} a {job.end ?? 'la actualidad'}
                                </span>
                            </div>
                        </li>
                    )
                    :
                    ''
            }
        </Fragment>
    )
}

export default withParams(JobItem);